var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_c('h4',[_vm._v(" Compiled on "+_vm._s(_vm.date)+" ")]),_vm._v(" "),_c('div',{attrs:{"id":"gdpview"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9568f54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/D3View.vue
// module id = null
// module chunks = 